import { Component } from "vuety";
import { IProductGroupItem } from "../../interfaces";
import { getRoot } from "../../root";
import { ListList } from "./listList";
import Vue from "vue";
import { BaseView } from "../base";

const templateElement = "v-tmpl-grouplist";

@Component({
	template: document.getElementById(templateElement) ? "#" + templateElement : require("./list.html"),
	components: { "list-list": ListList },
	mixins: [BaseView],
})
export class ListView extends Vue {
	public get groups(): IProductGroupItem[] {
		return getRoot().currentData.Groups;
	}
}



// WEBPACK FOOTER //
// ./src/views/list/list.ts